module.exports = __webpack_public_path__ + "static/media/appstorebadge.26978d7b.png";